export const carouselData = [
    {
        title: "All Products for Your Health",
        subtitle: "High-quality vitamins and dietary supplements for children, men, and women.",
        img: "https://res2.weblium.site/res/5fed3c09cf52350021e8c7d0/5ff92dab70c13a002257189c_optimized.webp",
        color: "rgb(245, 246, 250)",
        category: "Herbal Products"
    },
    {
        title: "Disease Prevention",
        subtitle: "Our vitamins will strengthen your immune system, stimulate the immune response to various infections. With proper vitamins, you will forget about seasonal colds.",
        img: "https://res2.weblium.site/res/5fed3c09cf52350021e8c7d0/5fee7ad270461300213d003f_optimized_800_c740x493-28x21?nowebp",
        color: "rgb(240, 242, 254)",
        category: "Supplements"

    },
    {
        title: "Vitamins for Hair",
        subtitle: "We have a huge selection of hair products that really work. Here you will find vitamins for weak, thin, brittle hair. With the presented products, your hair will become healthy, lush and silky.",
        img: "https://res2.weblium.site/res/5fed3c09cf52350021e8c7d0/5fee859ff1da56002223cdba_optimized_800_c695x556-0x84?nowebp",
        color: "rgb(255, 207, 162)",
        category: "Vitamins"
    },


]